module.exports = __webpack_public_path__ + "static/media/profile.9ec4584f.svg";